import { IShippingMethod } from '../../../domain/entities/ShippingMethodsCollection/ShippingMethodsCollection';
import { IShippingMethodResponse } from '../../IApiResponses';
import SHIPPING_METHODS from '../../../constants/ShippingMethods';

const deliveryMethodsMapper = {
  response(
    shippingOptions: IShippingMethodResponse[],
    selectedShippingMethodId?: SHIPPING_METHODS,
  ): IShippingMethod[] {
    const shippingMethods: IShippingMethod[] = [];
    /* istanbul ignore else */
    if (Array.isArray(shippingOptions)) {
      shippingOptions.forEach(method => {
        const unsupportedShipMethods = [
          'currency_code',
          'order_ship_method',
          // click and collect, this needs to be treated separately
          // only from data-config
          26,
        ];
        if (!unsupportedShipMethods.some(sm => method.ship_method_id === sm)) {
          const {
            discount,
            name,
            price,
            sku_base_id: skuId,
            sort_order: sortOrder,
            ship_method_id: id,
            country_ids: countryIds,
            lead_time_value: leadTimeValue,
            next_available_sat: nextAvailableSat,
            available_window: availableWindow,
            estimated_delivery_start_date: estimatedDeliveryStartDate,
            estimated_delivery_end_date: estimatedDeliveryEndDate,
          } = method;
          const selected = id === selectedShippingMethodId;
          const shipPrice = price !== undefined ? Number(price) : undefined;
          const totalPrice = shipPrice !== undefined ? shipPrice + discount : undefined;

          const shipMethod: IShippingMethod = {
            countryIds: countryIds?.map((countryId: string) => Number(countryId)) || [],
            discount,
            estimatedDeliveryEndDate,
            estimatedDeliveryStartDate,
            id: id as SHIPPING_METHODS,
            leadTimeValue,
            name,
            nextAvailableSat,
            price: shipPrice,
            selected,
            skuId,
            sortOrder,
            totalPrice,
          };
          if (availableWindow) {
            const {
              start_hour: startHour,
              stop_hour: stopHour,
              timezone: timeZone,
            } = availableWindow;
            shipMethod.availableWindow = { startHour, stopHour, timeZone };
          }
          shippingMethods.push(shipMethod);
        }
      });
    }

    return shippingMethods;
  },
};

export default deliveryMethodsMapper;
